module.exports = __webpack_public_path__ + "img/settings-header.d10a068d.png";